// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Support_searchMidle__-EOgf {
  display: flex;
  justify-content: flex-end;
  gap: 2rem;
  margin: 4rem 0 1rem;
}
@media only screen and (max-width: 43.75em) {
  .Support_searchMidle__-EOgf {
    flex-direction: column;
    align-items: center;
  }
}

.Support_btnContainer__Ubf1r {
  display: flex;
  justify-content: end;
  width: 100%;
  margin: 3rem 4rem;
}

.Support_modalContent__wlD0k {
  display: grid;
  grid-template-columns: 1fr;
  align-items: start;
  width: 100%;
  padding: 2rem;
}

.Support_filterClass__UWXK1 {
  display: flex;
  justify-content: space-between;
  margin-top: 8rem;
}
@media only screen and (max-width: 25em) {
  .Support_filterClass__UWXK1 {
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Support/Support.module.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,yBAAA;EACA,SAAA;EACA,mBAAA;AADD;AAGC;EAND;IAOE,sBAAA;IACA,mBAAA;EAAA;AACF;;AAGA;EACC,aAAA;EACA,oBAAA;EACA,WAAA;EACA,iBAAA;AAAD;;AAGA;EACC,aAAA;EACA,0BAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AAAD;;AAGA;EACC,aAAA;EACA,8BAAA;EACA,gBAAA;AAAD;AAEC;EALD;IAMC,sBAAA;EACC;AACF","sourcesContent":["@import '../variables/breakpoints';\n\n.searchMidle {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tgap: 2rem;\n\tmargin: 4rem 0 1rem;\n\n\t@media only screen and (max-width: $bp-700) {\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t}\n}\n\n.btnContainer {\n\tdisplay: flex;\n\tjustify-content: end;\n\twidth: 100%;\n\tmargin: 3rem 4rem;\n}\n\n.modalContent {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr;\n\talign-items: start;\n\twidth: 100%;\n\tpadding: 2rem;\n}\n\n.filterClass {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-top: 8rem;\n\n\t@media only screen and (max-width: $bp-400) {\n\tflex-direction: column;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchMidle": `Support_searchMidle__-EOgf`,
	"btnContainer": `Support_btnContainer__Ubf1r`,
	"modalContent": `Support_modalContent__wlD0k`,
	"filterClass": `Support_filterClass__UWXK1`
};
export default ___CSS_LOADER_EXPORT___;
